import React from "react";
import BRAND_IMAGES from "@/lib/brand";

const FinalCTA = ({ onRegister }) => {
  return (
    <section
      className="relative py-28 md:py-40 overflow-hidden bokeh-bg"
      style={{
        background:
          "radial-gradient(ellipse at top, #FBF1DA 0%, #F5EBD4 50%, #EFE2C2 100%)",
      }}
      data-testid="final-cta-section"
    >
      {/* Soft elegant portrait peek */}
      <div
        className="absolute right-0 top-0 bottom-0 w-full md:w-1/2 opacity-20 md:opacity-30 pointer-events-none"
        aria-hidden="true"
      >
        <img
          src={BRAND_IMAGES.hostPortraitAmalfi}
          alt=""
          className="w-full h-full object-cover object-center"
          style={{
            maskImage:
              "linear-gradient(to left, black 30%, transparent 95%)",
            WebkitMaskImage:
              "linear-gradient(to left, black 30%, transparent 95%)",
          }}
        />
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10 text-center">
        <h2
          className="font-serif text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight balance fade-up"
          style={{ color: "var(--ink)" }}
          data-testid="final-cta-headline"
        >
          You are not your
          <span
            className="font-script block text-6xl md:text-8xl mt-2"
            style={{ color: "var(--gold-deep)" }}
          >
            doing.
          </span>
        </h2>

        <p
          className="mt-8 font-serif italic text-[color:var(--ink-soft)] max-w-2xl mx-auto pretty fade-up delay-200"
          style={{ fontSize: "1.55rem", lineHeight: 1.35 }}
          data-testid="final-cta-copy"
        >
          What if the freedom you have been working so hard for is not
          something you build, but something you remember?
        </p>

        <p className="mt-5 text-[color:var(--ink-soft)] fade-up delay-300" style={{ fontSize: "1.2rem" }}>
          Do less. Be more. Begin the journey home.
        </p>

        <div className="mt-12 fade-up delay-400">
          <button
            onClick={onRegister}
            className="btn-primary"
            data-testid="final-cta-register-btn"
          >
            Register For Free
          </button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
